module.exports = __webpack_public_path__ + "static/media/toilet_paper.9b7116ab.svg";